import { render, staticRenderFns } from "./CertificateRecordLook.vue?vue&type=template&id=5475f182"
import script from "./CertificateRecordLook.vue?vue&type=script&lang=js"
export * from "./CertificateRecordLook.vue?vue&type=script&lang=js"
import style0 from "./CertificateRecordLook.vue?vue&type=style&index=0&id=5475f182&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports